import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import IlLibro from "@/pages/IlLibro";
import Corsi from "@/pages/Corsi";
import CorsoDettaglio from "@/pages/CorsoDettaglio";
import Podcast from "@/pages/Podcast";
import ChiSono from "@/pages/ChiSono";
import Storie from "@/pages/Storie";
import Articolo from "@/pages/Articolo";
import Contatti from "@/pages/Contatti";
import Grazie from "@/pages/Grazie";
import { Privacy, Cookie } from "@/pages/Legali";
import NotFound from "@/pages/NotFound";
import PagamentoEsito from "@/pages/PagamentoEsito";
import LandingLibro from "@/pages/LandingLibro";
import Lancio from "@/pages/Lancio";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    let vid = localStorage.getItem("dic_visitor_id");
    if (!vid) {
      vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("dic_visitor_id", vid);
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: vid, path: pathname }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname]);
  return null;
}

function SiteShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isLanding = pathname.startsWith("/lp");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }

  if (isLanding) {
    return (
      <>
        <Routes>
          <Route path="/lp/libro" element={<LandingLibro />} />
          <Route path="/lp/*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A1614", color: "#F4EFE9", border: "1px solid rgba(176,131,47,0.3)" } }} />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lancio" element={<Lancio />} />
          <Route path="/il-libro" element={<IlLibro />} />
          <Route path="/corsi" element={<Corsi />} />
          <Route path="/corsi/:slug" element={<CorsoDettaglio />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/chi-sono" element={<ChiSono />} />
          <Route path="/storie" element={<Storie />} />
          <Route path="/storie/:slug" element={<Articolo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/grazie" element={<Grazie />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<Cookie />} />
          <Route path="/pagamento/successo" element={<PagamentoEsito ok />} />
          <Route path="/pagamento/annullato" element={<PagamentoEsito />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
      <ChatWidget />
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A1614", color: "#F4EFE9", border: "1px solid rgba(176,131,47,0.3)" } }} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <VisitTracker />
        <SiteShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
